(function() {
  'use strict';

  angular
    .module('contentPlayer.contentErrorModal', [])
    .controller('ContentErrorModal', ContentErrorModal);

  ContentErrorModal.$inject = ['$scope', 'Navigation', '$window', 'MobileHelper'];

  function ContentErrorModal($scope, Navigation, $window, MobileHelper) {
    $scope.modalOk = function() {
      if ($scope.contentErrorModal.url)
        $window.open($scope.contentErrorModal.url);
      if ($scope.contentErrorModal.redirectToDashboard) {
        if (Navigation.playerType === 'trainerPreview' && !MobileHelper.isNativeIpadApp)
          $window.close();
        else
          Navigation.navigate(Navigation.directions.exit);
      }
      $scope.$close();
    };
  }
})();
